import type { ReactNode } from "react"

/** A record name with its status badges; long names wrap and badges drop to the next line instead of squeezing. */
export function NameWithBadges({ name, children }: { name: string; children?: ReactNode }) {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
      <span className="font-medium [overflow-wrap:anywhere]">{name}</span>
      {children}
    </div>
  )
}
